// @flow

const INITIAL_STATE = {
    domainId: null,
    snapshot: null,
    loading: false,
    error: null,
};

const Throttling = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'THROTTLING_LOAD':
            return { ...state, domainId: action.payload.domainId, loading: true, error: null };
        case 'THROTTLING_LOADED':
            if (state.domainId !== null && state.domainId !== action.payload.domainId) return state;
            return { ...state, domainId: action.payload.domainId, snapshot: action.payload.snapshot, loading: false, error: null };
        case 'THROTTLING_FAILED':
            if (state.domainId !== null && state.domainId !== action.payload.domainId) return state;
            return { ...state, domainId: action.payload.domainId, loading: false, error: action.payload.error };
        case 'THROTTLING_STOP':
            return state;
        default:
            return state;
    }
};

export default Throttling;
